function Company() {

    return <h1>Empresa</h1>

}

export default Company